module.exports = __webpack_public_path__ + "media/images/landing/avatar_all-3d4714411bfbd23cb7f8f634c68c6069.png";